export default "__VITE_ASSET__DMG93DGU__"